import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export interface AdressevaelgerResult {
  id?: string;
  type: string;
  titel: string;
  vejnavn?: string;
  vejNavn?: string;
  husnummer?: string;
  postnr?: string;
  postdistrikt?: string;
}

export interface AdressevaelgerResponse {
  status: string;
  fund: AdressevaelgerResult[];
}

export interface AdressevaelgerHusnummerResponse {
  status: string;
  husnummer: {
    vejnavn: string;
    husnummertekst: string;
    postnummer: { postnr: string; navn: string };
  };
}

export interface AdressevaelgerAdresseResponse {
  status: string;
  adresse: {
    husnummer: AdressevaelgerHusnummerResponse['husnummer'];
  };
}

@Injectable({
  providedIn: 'root',
})
export class DavaService {
  adressevaelgerEndpoint = 'https://adressevaelger.dk';
  adressevaelgerToken = 'adressevaelger123';

  constructor(private http: HttpClient) {}

  // Usede to autocomplete adress
  /*   davaAutoComplete(address: string): Observable<any> {
    return this.http
      .get<any>(
        'https://api.dataforsyningen.dk/adresser/autocomplete?q=' + address,
      )
      .pipe(
        map((result) => {
          return result;
        }),
        catchError((error) => {
          console.error(error);
          return throwError(() => error);
        }),
      );
  } */

  adressevaelgerAutoComplete(
    query: string,
  ): Observable<AdressevaelgerResponse> {
    const params = new HttpParams()
      .set('tekst', query)
      .set('token', this.adressevaelgerToken);

    return this.http.get<AdressevaelgerResponse>(
      `${this.adressevaelgerEndpoint}/husnumre/soeg`,
      { params },
    );
  }

  adressevaelgerHusnumreForVej(
    vejnavn: string,
    postnummer?: string,
  ): Observable<AdressevaelgerResponse> {
    let params = new HttpParams()
      .set('vejnavn', vejnavn)
      .set('token', this.adressevaelgerToken);

    if (postnummer) {
      params = params.set('postnummer', postnummer);
    }

    return this.http.get<AdressevaelgerResponse>(
      `${this.adressevaelgerEndpoint}/husnumre/soeg`,
      { params },
    );
  }

  adressevaelgerHusnummerById(
    id: string,
  ): Observable<AdressevaelgerHusnummerResponse> {
    return this.http.get<AdressevaelgerHusnummerResponse>(
      `${this.adressevaelgerEndpoint}/husnumre/${encodeURIComponent(id)}`,
      { params: new HttpParams().set('token', this.adressevaelgerToken) },
    );
  }

  adressevaelgerAdresseById(
    id: string,
  ): Observable<AdressevaelgerAdresseResponse> {
    return this.http.get<AdressevaelgerAdresseResponse>(
      `${this.adressevaelgerEndpoint}/adresser/${encodeURIComponent(id)}`,
      { params: new HttpParams().set('token', this.adressevaelgerToken) },
    );
  }

  // Used to set city name based on zipCode
  /*   davaZipCodeSearch(zipCode: number): Observable<any> {
    return this.http
      .get<any>('https://api.dataforsyningen.dk/postnumre?nr=' + zipCode)
      .pipe(
        map((result) => {
          return result;
        }),
        catchError((error) => {
          console.error(error);
          return throwError(() => error);
        }),
      );
  } */
}
